import classes from './Spinner.module.css';

type SpinnerProps = {
  label?: string;
  color?: string;
  size?: number;
};
export const Spinner = ({ label, color, size }: SpinnerProps) => {
  return (
    <span
      className={classes.spinner}
      style={{
        borderColor: color,
        borderBottomColor: 'transparent',
        width: size,
        height: size,
      }}
      role="status"
      aria-label={label}
    ></span>
  );
};
